/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q6_AnswerInputs */

const en_faq_q6_answer = /** @type {(inputs: Faq_Q6_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An exclusion refers to a medical service or medication not covered by your insurance. These will be listed under the Exclusion section of your policy. Always fully read your policy or call emergency assistance for details.`)
};

const fr_faq_q6_answer = /** @type {(inputs: Faq_Q6_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une exclusion désigne un service médical ou un médicament non couvert par votre assurance. Ceux-ci seront répertoriés dans la section Exclusions de votre police. Lisez toujours attentivement votre police ou appelez l'assistance d'urgence pour plus de détails.`)
};

/**
* | output |
* | --- |
* | "An exclusion refers to a medical service or medication not covered by your insurance. These will be listed under the Exclusion section of your policy. Always..." |
*
* @param {Faq_Q6_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q6_answer = /** @type {((inputs?: Faq_Q6_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q6_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q6_answer(inputs)
	return fr_faq_q6_answer(inputs)
});